import React, { useEffect, useState } from 'react';
import Modal from '../../components/Modal';
import Title from '../../components/Title';
import SbTextField from '../../components/Textfield';
import SBDropdown from '../../components/Dropdown';
import SbButton, { SbLoadingButton } from '../../components/Button';
import { Grid } from '@mui/material';
import { BULKSTATUS, SHIPMENT_STATUS } from '@Constants/Shipment';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootStateType } from '@Store';
// import { UpdateShipmentStatus } from '@Reducers/ShipmentHistory';
// import { UpdateShipmentStatusPostData } from '@Reducers/ShipmentHistory/Type';
import { SuccessErrorModalOpen, SuccessErrorModalReset } from '@Reducers/SuccessErrorModal';
import { BulkStatusUpdate } from '@Reducers/ShipmentHistory/actions';
import { BulkStatusUpdateType } from './BulkStatusUpload/types';
import { setSelectedShipments } from '@Reducers/ShipmentHistory';

interface PropsType {
  isOpen: boolean;
  handleClose: () => void;
  selectedShipments: string[];
}

const StatusList = Object.values(SHIPMENT_STATUS)
  .filter(s => !['void', 'cancelled'].includes(s.value))
  .map(s => ({
    display: s.label,
    value: s.value,
  }));

export default function UpdateStatus({ isOpen, handleClose, selectedShipments }: PropsType) {
  const [messgae, setMessage] = useState<string>('');
  const [location, setLocation] = useState<string>('');
  const [status, setStatus] = useState<string>('');

  const {
    loading,
    success,
    selectedShipments: selectedShipmentsData,
  } = useSelector((state: RootStateType) => state.shipmentHistory);
  // const _userId = useSelector((state: RootStateType) => state.loginUser.profile?._id) || '';

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (success) {
      handleClose();
    }
  }, [success]);

  const isValidStatusTransition = (selectedShipments: typeof selectedShipmentsData, newStatus: string): boolean => {
    const invalidTransitions: { id: string; from: string }[] = [];

    // ✅ Allowed statuses if already in_transit
    const inTransitAllowedStatuses = ['delivered', 'rto', 'shipment_exception', 'void', 'at_warehouse', 'in_transit'];

    for (const shipmentId in selectedShipments) {
      const { status: currentStatus } = selectedShipments[shipmentId];

      // ✅ If current status is in_transit → enforce allowed statuses
      if (currentStatus === 'in_transit') {
        if (!inTransitAllowedStatuses.includes(newStatus)) {
          invalidTransitions.push({ id: shipmentId, from: currentStatus });
          continue;
        }
      } else {
        // ✅ Normal BULKSTATUS transition check
        const validNextStatuses = BULKSTATUS[currentStatus]?.map(s => s.value) || [];

        if (!validNextStatuses.includes(newStatus)) {
          invalidTransitions.push({ id: shipmentId, from: currentStatus });
        }
      }
    }

    // ✅ Handle invalid transitions
    if (invalidTransitions.length > 0) {
      const list = invalidTransitions
        .map(
          ({ id, from }) =>
            `• Shipment ${id} cannot move from ${SHIPMENT_STATUS[from]?.label} to ${SHIPMENT_STATUS[newStatus]?.label}`,
        )
        .join('\n');

      dispatch(
        SuccessErrorModalOpen({
          type: 'error',
          title: 'Cannot change status',
          subTitle: list,
          format: true,
        }),
      );

      return false;
    }

    return true;
  };

  async function handleStatusUpdate() {
    const postData: BulkStatusUpdateType = {
      shipmentNumbers: [...selectedShipments],
      location,
      msg: messgae || SHIPMENT_STATUS[status]?.msg || '-',
      status: status,
    };

    if (isValidStatusTransition(selectedShipmentsData, status)) {
      const data = await dispatch(BulkStatusUpdate(postData));
      if (data?.payload?.status === 200) {
        dispatch(
          SuccessErrorModalOpen({
            type: 'success',
            title: 'Success',
            subTitle: data.payload.msg,
            onConfirm: () => {
              handleModalClose();
              dispatch(SuccessErrorModalReset());
              dispatch(setSelectedShipments({}));
            },
          }),
        );
      }
    }
  }
  function handleModalClose() {
    setMessage('');
    setLocation('');
    setStatus('');
    handleClose();
  }
  // const updatedStatusList = StatusList?.filter(status => status.value !== 'forwarded');

  return (
    <Modal
      open={isOpen}
      dialogContainerSx={{
        paddingTop: 1,
        paddingRight: 1,
        paddingLeft: 3,
      }}
      onClose={handleModalClose}
    >
      <div className="pr-2 pt-1" style={{ width: '580px' }}>
        <div style={{ textAlign: 'center' }}>
          <Title title="Status" subTitle="Update status for selected shipments" removeBorder />
        </div>
        <Grid container mb={2}>
          <SbTextField
            label="Message"
            name="message"
            className="w-full"
            onChange={e => setMessage(e.target.value)}
            value={messgae}
          />
        </Grid>
        <Grid container mb={2}>
          <SbTextField
            label="Location"
            name="location"
            className="w-full"
            onChange={e => setLocation(e.target.value)}
            value={location}
          />
        </Grid>
        <Grid container mb={2}>
          <SBDropdown
            id="company-country-id"
            label="Status"
            name="status"
            value={[status]}
            // options={StatusList}
            options={StatusList}
            onChange={([value]) => setStatus(value)}
          />
        </Grid>
        <div className="flex mt-3" style={{ justifyContent: 'center' }}>
          <SbButton variant="outlined" sx={{ borderRadius: '8px !important', mr: 1 }} onClick={handleClose}>
            Cancel
          </SbButton>
          <SbLoadingButton
            variant="contained"
            sx={{ borderRadius: '8px !important', ml: 1 }}
            onClick={handleStatusUpdate}
            loading={loading}
          >
            Update
          </SbLoadingButton>
        </div>
      </div>
    </Modal>
  );
}
